'use client';
import { create } from 'zustand';

export type WorkspaceMode = 'builder' | 'artifact' | 'none';

type State = {
  mode: WorkspaceMode;
  setMode: (m: WorkspaceMode) => void;
  openArtifact: () => void;
  openBuilder: () => void;
};

export const useWorkspace = create<State>((set) => ({
  mode: 'builder',
  setMode: (mode) => set({ mode }),
  openArtifact: () => set({ mode: 'artifact' }),
  openBuilder: () => set({ mode: 'builder' }),
}));